
import { Button } from "@/components/ui/button";
import { Film, PlusCircle } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface FilmEmptyStateProps {
  searchQuery?: string;
  onAddClick: () => void;
}

export function FilmEmptyState({ searchQuery, onAddClick }: FilmEmptyStateProps) {
  const { t } = useTranslation();
  
  return (
    <div className="text-center p-8 border rounded-lg bg-muted/10">
      {searchQuery ? (
        <p className="text-muted-foreground">{t('no_films_found')} "{searchQuery}"</p>
      ) : (
        <div className="space-y-4 flex flex-col items-center">
          <Film className="h-16 w-16 text-muted-foreground opacity-20" />
          <div>
            <p className="text-muted-foreground mb-2">{t('no_films_yet')}</p>
            <Button variant="outline" onClick={onAddClick}>
              <PlusCircle className="h-4 w-4 mr-1" />
              {t('add_first_film')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
